import { render, staticRenderFns } from "./bothSides.vue?vue&type=template&id=291aae64&scoped=true&"
import script from "./bothSides.vue?vue&type=script&lang=js&"
export * from "./bothSides.vue?vue&type=script&lang=js&"
import style0 from "./bothSides.vue?vue&type=style&index=0&id=291aae64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291aae64",
  null
  
)

export default component.exports